import React, { useEffect, useState } from "react";
import "./TitleSubtitlePageHeader.css";
import { ReactComponent as LeftBoxGraphic } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RightGraphic } from "images/background/right-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as LeftGraphic } from "images/background/left-box-graphic.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";


export default function index({ title, subtitle, subtitle2, subtitle3, introduction, subtitleColorGreen, activeBtn, hoverBtnHandle, blurBtnHandle, clickHandle, ref }) {


  return (
    <div>
      <div className="title-subtitle-page-header">
        <div className="hg-bg-left">
          <LeftBoxGraphic />
        </div>
        <div className="rightFrame">
          <RightGraphic className="RightFrame-svg" />
        </div>
        <div className="rightBox">
          <RightBox className="RightBox-svg" />
        </div>
        <div className="header">
          <h2 className="mb-5"><FormattedMessage id={title} /></h2>
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center p-2">
            {subtitle ?
              <Link
                to="/merchant-service"
                className={subtitleColorGreen ? activeBtn === "merchant-service" ? 'active primary blue' : "primary blue" : activeBtn ? "active accent blue" : "accent blue"}
                onMouseEnter={hoverBtnHandle}
                onMouseLeave={blurBtnHandle}
                onClick={clickHandle}
              >
                <FormattedMessage id={subtitle} />
              </Link> : null}

            {subtitle2 ?
              <Link
                to="/browse-by-use-cases"
                className={subtitleColorGreen ? activeBtn === "browse-by-use-cases" ? 'active primary red' : 'primary red' : activeBtn ? "active accent red" : "accent red"}
                onMouseEnter={hoverBtnHandle}
                onMouseLeave={blurBtnHandle}
              >
                <FormattedMessage id={subtitle2} />
              </Link> : null}

            {subtitle3 ?
              <Link
                to="/service-rate"
                className={subtitleColorGreen ? activeBtn === "service-rate" ? 'active primary blue' : 'primary blue' : activeBtn ? "active accent blue" : "accent blue"}
                onMouseEnter={hoverBtnHandle}
                onMouseLeave={blurBtnHandle}
                onClick={clickHandle}
              >
                <FormattedMessage id={subtitle3} />
              </Link> : null}
          </div>
          {/* modified code */}
          <h3 className="mt-5 me-5 ms-5"><FormattedMessage id={introduction} /></h3>
        </div>
        <div>
          <div className="leftFrame">
          </div>
        </div>
      </div>
    </div>
  );
}
